import React from 'react';
import firebase from '../firebase';
import { useHistory } from 'react-router-dom';

export const Component = () => {
  const history = useHistory();
  const [sending, setSending] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string>();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    const target: any = e.target;
    const email = target.email.value;
    e.preventDefault();
    setSending(true);
    firebase
      .auth()
      .signInWithEmailLink(email, window.location.href)
      .then(function (result) {
        history.push('/');
      })
      .catch(function (error) {
        setError(error.code);
        console.error(error.code);
      });
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div>
          <div>
            <label htmlFor="email">email</label>
            <input id="email" name="email" />
          </div>
          <div>
            <button disabled={sending}>Log in</button>
          </div>
          {error && <div>{error}</div>}
        </div>
      </form>
    </div>
  );
};
